export default "__VITE_ASSET__4bf65e2e__"